import type { FC } from 'react';
import React from 'react';

import { MuiFloatButton } from 'shared/ui-kit';

import {
  SmallStubButtonContainer,
  SmallStubContainer,
  SmallStubDescription,
  SmallStubImageContainer,
  SmallStubSubDescription,
  SmallStubTitle,
} from './SmallStub.style';

type ValueProps = {
  title?: string;
  description: string;
  subDescription?: string;
  img: string;
  imageAlt: string;
};

type Props = {
  value: ValueProps;
  onClickButton?: () => void;
};

// TODO - remove after redesign chat
export const SmallStub: FC<Props> = ({ value, onClickButton }) => {
  return (
    <SmallStubContainer>
      {value.title && <SmallStubTitle variant="h2">{value.title}</SmallStubTitle>}

      <SmallStubDescription variant="large">{value.description}</SmallStubDescription>

      {!!onClickButton && (
        <SmallStubButtonContainer>
          <MuiFloatButton size="small" onClick={onClickButton} />
        </SmallStubButtonContainer>
      )}

      <SmallStubImageContainer>
        <img src={value.img} alt={value.imageAlt} style={{ width: '100%' }} />
      </SmallStubImageContainer>

      {value.subDescription && (
        <SmallStubSubDescription variant="small">{value.subDescription}</SmallStubSubDescription>
      )}
    </SmallStubContainer>
  );
};
